<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="部门:" prop="gzbm">
                        <el-input
                        v-model="queryParams.gzbm"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <!-- <el-form-item label="编码:" prop="bm">
                        <el-input
                        v-model="queryParams.bm"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <!-- <el-button type="danger" v-if="xz=='1'" icon="el-icon-plus" size="small" @click="handleAdd">新增</el-button> -->
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="ajslList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="工作部门" align="center" prop="gzbm" />
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                        <el-button 
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row)"
                        >编辑</el-button>
                        <el-button v-if="sc=='1'"
                            size="small"
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <el-dialog title="工作部门信息" :visible.sync="open" width="600px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <!-- <el-form-item label="编码:" prop="bm">
                        <el-input :disabled="form.id?true:false" v-model="form.bm" clearable placeholder="请输入" ></el-input>
                    </el-form-item> -->
                    <el-form-item label="工作部门:" prop="gzbm">
                        <el-input v-model="form.gzbm" clearable placeholder="请输入工作部门" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" size="small" @click="onSubmit('form')">确定</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            queryParams:{
                gzbm:'',
                bm:'',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            open:false,
            pageshow:true,
            form:{},
            rules:{
                bm: [
                    { required: true, message: '编码不能为空', trigger: 'blur' }
                ],
                gzbm: [
                    { required: true, message: '工作部门不能为空', trigger: 'blur' }
                ],
            },
            sc: "",
            xg: "",
            xz: "",
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '工作部门'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.baseUrl = user.baseUrl
        this.getList()
    },
    methods: {
        getList(){
            this.ajslList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getgzbm`,
                data:{
                    gzbm:this.queryParams.gzbm,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.ajslList = res.data.data.list
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){
            this.form = {}
            this.open = true
        },
        handleEdit(row){
            this.form = {}
            this.open = true
            this.form = row
        },
        handleDelete(row){
            this.$confirm("您确认要删除这条记录吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/getIdDelGzbm`,
                    data:{
                        id: row.id
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    this.open = false
                    if(res.data.code == 0 && res.data.data){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getList()
                    }else{
                        if(res.data.msg){
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(error => {
                    this.$message.error(error);
                })   
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        resetQuery(){
            this.queryParams = {
                gzbm:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        cancel(){
            this.form = {}
            this.open = false
        },
        onSubmit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    axios({
                        method: 'post',
                        url: this.baseUrl+`/login/editGzbm`,
                        data:{
                            gzbm:this.form.gzbm,
                            id: this.form.id
                        },
                        headers: { 
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        this.open = false
                        if(res.data.code == 0){
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            });
                            this.getList()
                        }else{
                            if(res.data.msg){
                                this.$message.error(res.data.msg)
                            }
                        }
                    }).catch(error => {
                        this.$message.error(error);
                    })
                }
            })
        }
    }
}
</script>


<style scoped>
</style>